import styled from 'styled-components';

interface HeaderSectionProps {
  isItemsVisible: boolean;
}

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: ${(p) => p.theme.spacing.xLarge};
`;

export const WrapperFilter = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${(p) => p.theme.font.small};
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const WrapperContent = styled.div`
  flex: 1;
  width: 100%;
`;

export const SectionFilter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.small};

  border-bottom: 1px solid ${(p) => p.theme.colors.border};

  padding: ${(p) => p.theme.spacing.medium} 0;

  width: 200px;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export const HeaderSection = styled.div<HeaderSectionProps>`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(p) => p.theme.spacing.small};
  color: ${(p) => p.theme.colors.primary};

  transition: opacity 0.4s;
  will-change: opacity;

  &:hover {
    opacity: 0.6;
  }

  svg {
    width: ${(p) => p.theme.font.large};
    height: ${(p) => p.theme.font.large};
    stroke-width: 3;

    transition: transform 0.3s;
    will-change: transform;
    transform: ${(p) => (p.isItemsVisible ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const Title = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`;

export const Option = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing.small};

  cursor: pointer;
  font-weight: 300;

  transition: opacity 0.3s;
  will-change: opacity;

  &:hover {
    opacity: 0.5;
  }

  > input {
    cursor: pointer;
    width: 10px;
    height: 10px;
  }
`;

export const WrapperOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.small};
`;
